import React from 'react';

import { FormattedMessage } from 'component-utilities/intl';

const SIMPLE_DOMAIN = '^[A-Za-z0-9-.]{1,63}\\.[A-Za-z]{2,15}$';

export default function domainError(domainName) {
  const isDomainValid = new RegExp(SIMPLE_DOMAIN).test(domainName);

  if (domainName.length && !isDomainValid) {
    return <FormattedMessage id="components.email_domains.invalid_domain" />;
  }

  return null;
}

export function isValidDomain(domain) {
  return domain.length && new RegExp(SIMPLE_DOMAIN).test(domain);
}
